import { FeedbackListDrawer } from '@modules/feedback/components/FeedbackListDrawer';
import { LinkRounded } from '@mui/icons-material';
import { Box, Stack, Typography } from '@mui/material';
import { EqlField } from 'generated/graphql';
import { QueryContainer } from 'v2/core/services/notebook/types';

interface MetadataFieldMappingFeedbackDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  sourceEqlField: EqlField;
  targetEqlField: EqlField;
  queryContainer: QueryContainer;
}

export const MetadataFieldMappingFeedbackDrawer = ({
  isOpen,
  onClose,
  sourceEqlField,
  targetEqlField,
  queryContainer,
}: MetadataFieldMappingFeedbackDrawerProps) => {
  const renderEqlFieldDescription = (eqlField: EqlField) => {
    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box
          width="24px"
          component="img"
          alignSelf="center"
          src={eqlField.iconURL}
          alt={eqlField.displayName}
        />
        <Typography color="text.secondary">
          {eqlField.detail?.metadata?.source} -{' '}
        </Typography>
        <Typography>{eqlField.displayName}</Typography>
      </Stack>
    );
  };

  return (
    <FeedbackListDrawer
      shouldHideOpenInSearch
      open={isOpen}
      onClose={onClose}
      queryContainer={queryContainer}
      header={{
        shouldEnableSort: false,
        renderTitle: () => (
          <Typography variant="subtitle2" color="text.secondary">
            Feedback for
          </Typography>
        ),
        renderDescription: () => (
          <Stack direction="row" alignItems="center" spacing={3} pt={1}>
            {renderEqlFieldDescription(targetEqlField)}
            <LinkRounded
              sx={{
                color: 'success.light',
                fontSize: '2rem',
              }}
            />
            {renderEqlFieldDescription(sourceEqlField)}
          </Stack>
        ),
      }}
    />
  );
};
